import { useCallback, useMemo, useState } from "react";
import { Guid } from "guid-typescript";
import { Signal } from "../services/signal";

export function useSignal(url: string): [Signal, string] {
  const [trigger, setTrigger] = useState<any>(null);
  const fn = useCallback(() => {
    setTrigger(Guid.create().toString());
  }, []);
  const signal = useMemo(() => new Signal(url, fn), []);

  return [signal, trigger];
}
